var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import { withTheme } from "styled-components";
import { lazyOptions, placeholderSrc } from "./shared";
var defaultStyles = {
    display: "block",
    width: "100%",
    height: "auto",
};
var Picture = withTheme(function (_a) {
    var src = _a.src, theme = _a.theme, alt = _a.alt, style = _a.style, rest = __rest(_a, ["src", "theme", "alt", "style"]);
    var BPs = theme.breakpoints.map(function (str) { return parseInt(str.replace("px", "")); });
    var mobile = src[0];
    return (React.createElement("picture", null,
        React.createElement("source", { media: "(max-width:".concat(BPs[0] - 1, "px)"), srcSet: mobile }),
        src.slice(1).map(function (url, i) {
            var min = BPs[i];
            var max;
            var mq;
            if (i < src.length - 1) {
                max = BPs[i + 1] - 1;
                mq = "(min-width: ".concat(min, "px) and (max-width: ").concat(max, "px)");
            }
            else {
                max = BPs[i];
                mq = "(min-width: ".concat(min, "px)");
            }
            return React.createElement("source", { key: i, media: mq, srcSet: url });
        }),
        React.createElement("img", __assign({ src: src[src.length - 1], alt: alt, style: __assign(__assign({}, defaultStyles), style) }, rest))));
});
export var LazyPicture = withTheme(function (_a) {
    var style = _a.style, alt = _a.alt, width = _a.width, height = _a.height, rest = __rest(_a, ["style", "alt", "width", "height"]);
    var _b = useInView(lazyOptions), ref = _b[0], inView = _b[1];
    var _c = useState(false), isLoaded = _c[0], setLoaded = _c[1];
    return (React.createElement("div", { ref: ref, style: __assign({ position: "relative" }, style) }, inView ? (React.createElement(Picture, __assign({ alt: alt }, rest, { onLoad: inView ? function () { return setLoaded(true); } : function () { }, style: __assign(__assign(__assign({}, defaultStyles), { transition: "opacity 300ms", opacity: isLoaded ? 1 : 0 }), style), width: width, height: height }))) : (React.createElement("img", { alt: alt, src: placeholderSrc([width, height]), width: width, height: height, style: { display: "block" } }))));
});
export default (function (_a) {
    var lazyLoad = _a.lazyLoad, props = __rest(_a, ["lazyLoad"]);
    return lazyLoad ? React.createElement(LazyPicture, __assign({}, props)) : React.createElement(Picture, __assign({}, props));
});
//# sourceMappingURL=Picture.js.map